import React, { Fragment } from "react";
import {
  Table,
  TableHeader,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  NoDataFound,
} from "../../../../../components/table/tableComponent";
import { TbEdit } from "react-icons/tb";
import { HiOutlineTrash } from "react-icons/hi";
import DefaultButton from "../../../../../components/buttons/defaultButton";
import Loading from "../../../../../components/skeleton/loading";
import { useNavigate } from "react-router-dom";
import DefaultInput from "../../../../../components/inputs/defaultInput";
import DefaultAvatar from "../../../../../components/avatar/defaultAvatar";
import pic from "../../../../../assets/images/profile-sample.jpg";
import DefaultBadge from "../../../../../components/badge/defaultBadge";
import { dateFormat } from "../../../../../../utils/helper";
import { IoCheckmark } from "react-icons/io5";
import { IoMdClose } from "react-icons/io";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import LinkButton from "../../../../../components/buttons/linkButton";
import TableSkeleton from "../../../../../components/skeleton/tableSkeleton";
import ConfirmModal from "../../../../../components/modals/ConfirmModel";

const SalaryReportTable = ({
  tableData = [],
  handleStatus,
  onConfirm,
  isOpen,
  setIsOpen,
  loading,
  toggleModal,
}) => {
  const navigate = useNavigate();

  const headers = [
    "Name",
    "Salary date",
    "Department id",
    "Created by",
    "Status",
    "Action",
  ];

  return (
    <div className="flex flex-col gap-2">
      <Fragment>
        <Table className="shadow-md overflow-x-auto">
          <TableHeader>
            <TableRow>
              {headers.map((header, index) => (
                <TableHead
                  className={`min-w-[150px] ${
                    index === 0
                      ? "sticky left-0 bg-light" // sticky for first column
                      : ""
                  } ${index === headers.length - 1 ? "bg-light" : ""}`}
                  key={index}
                >
                  <span className="flex justify-between items-center">
                    {header}
                  </span>
                </TableHead>
              ))}
            </TableRow>
          </TableHeader>

          <TableBody>
            {loading ? (
              <TableSkeleton colSpan={headers.length} />
            ) : (
              <>
                {tableData && tableData.length > 0 ? (
                  tableData.map((data, index) => (
                    <TableRow key={index}>
                      <TableCell className="sticky left-0 bg-white z-10">
                        <span className="flex flex-row gap-1 items-center">
                          {data?.name}
                        </span>
                      </TableCell>
                      <TableCell> {dateFormat(data?.salary_date)}</TableCell>
                      <TableCell> {data?.department?.name}</TableCell>
                      <TableCell> {data?.created_by.name}</TableCell>

                      <TableCell>
                        <DefaultBadge status={data?.status} />{" "}
                      </TableCell>
                      <TableCell className="flex flex-row gap-2">
                        {/* Approved Rejected */}
                        <LinkButton
                          className="text-textLight"
                          onClick={
                            "/payroll/salary-report/details/" + data.uuid
                          }
                          name={<MdOutlineRemoveRedEye />}
                          variant="iconButton"
                          classnames="text-error-500"
                        />
                        <DefaultButton
                          onClick={() =>
                            handleStatus(data.uuid, index, "rejected")
                          }
                          name={<IoMdClose />}
                          variant="iconButton"
                          classnames="text-error-500"
                          disabled={data?.status === 1}
                        />
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <NoDataFound
                    colSpan={headers.length}
                    text="No Report Found."
                  />
                )}
              </>
            )}
          </TableBody>
        </Table>
      </Fragment>
      <ConfirmModal
        isOpen={isOpen}
        title="Are you sure?"
        message="Do you want Reject Report Please confirm."
        onConfirm={onConfirm}
        onCancel={() => setIsOpen(false)}
      />
    </div>
  );
};

export default SalaryReportTable;
